import {
  SPECIFICATION_LIST,
  VEHICLE_LIST,
  EDIT_NUMBERPLATE,
  LOCATION_LIST,
  SERVICE_LIST,
} from "@numberplateaction";

export function specList(state = {}, action) {
  if (action.type === SPECIFICATION_LIST) {
    return action.payload;
  }
  return state;
}

export function vehicleList(state = {}, action) {
  if (action.type === VEHICLE_LIST) {
    return action.payload;
  }
  return state;
}

export function editNumberplate(state = {}, action) {
  if (action.type === EDIT_NUMBERPLATE) {
    return action.payload;
  }
  return state;
}

export function locationList(state = {}, action) {
  if (action.type === LOCATION_LIST) {
    return action.payload;
  }
  return state;
}

export function serviceList(state = {}, action) {
  if (action.type === SERVICE_LIST) {
    return action.payload;
  }
  return state;
}
